import { useState } from 'react';

export default function TrainingPrograms() {
  const [selectedProgram, setSelectedProgram] = useState<any>(null);

  const scrollToInquiryForm = () => {
    const inquirySection = document.getElementById('product-inquiry');
    if (inquirySection) {
      inquirySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleEnrollNow = () => {
    window.open('https://paystack.shop/pay/vm-l-9hm83', '_blank');
  };

  const handleLearnMore = (program: any) => {
    setSelectedProgram(program);
  };

  const programs = [
    {
      title: 'BSF Farming Fundamentals',
      level: 'Beginner',
      duration: '1 Day',
      price: 'GHS 1,000',
      image: 'https://public.readdy.ai/ai/img_res/3efa5218752b5abbd89528a6257d063f.jpg',
      topics: [
        'Introduction to BSF biology and lifecycle',
        'Setting up your first BSF farm',
        'Waste management and feeding protocols',
        'Basic harvesting techniques',
        'Safety and biosecurity measures'
      ],
      fullDescription: 'This comprehensive 1-day program is designed for beginners who want to start their journey in Black Soldier Fly farming. You will learn the fundamentals of BSF biology, lifecycle management, and basic farming techniques. Our experienced instructors will guide you through hands-on sessions covering everything from setting up your first farm to implementing proper waste management protocols.',
      includes: [
        'Training materials',
        'Certificate of completion',
        'Starter BSF colony kit',
        'Access to online resources',
        'Post-training support for 3 months'
      ],
      schedule: 'Next session starts from January 2026. Sessions held on Fridays and Saturdays, 4 hours per session.',
      showEnroll: true
    },
    {
      title: 'Advanced BSF Production',
      level: 'Advanced',
      duration: '2 Days',
      price: 'GHS 1,500',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20insect%20farming%20training%20with%20professional%20equipment%20demonstration%2C%20technical%20workshop%20on%20Black%20Soldier%20Fly%20production%20optimization%2C%20agricultural%20experts%20teaching%20BSF%20breeding%20systems%2C%20modern%20farming%20facility%20tour%20with%20cultivation%20trays%2C%20hands-on%20practice%20with%20BSF%20processing%20machinery%2C%20sustainable%20protein%20production%20techniques%2C%20professional%20agricultural%20education%20setting&width=600&height=400&seq=bsf-training-advanced-002&orientation=landscape',
      topics: [
        'Optimizing breeding conditions',
        'Large-scale production systems',
        'Quality control and product processing',
        'Business planning and market access',
        'Advanced waste conversion techniques'
      ],
      fullDescription: 'Take your BSF farming to the next level with our advanced 2-day intensive program. This course focuses on scaling operations, optimizing production efficiency, and implementing quality control measures. Perfect for farmers looking to expand their operations or improve existing systems. Learn from industry experts with years of commercial BSF farming experience.',
      includes: [
        'Advanced training manual',
        'Professional certification',
        'Farm design consultation',
        'Business plan template',
        'Lifetime access to alumni network',
        '6 months post-training support'
      ],
      schedule: 'Next session starts from January 2026. Sessions held on Thursdays, 4 hours per session.',
      showEnroll: true
    },
    {
      title: 'BSF Product Processing',
      level: 'Intermediate',
      duration: '2 Days',
      price: 'On Request',
      image: 'https://readdy.ai/api/search-image?query=BSF%20product%20processing%20training%20workshop%2C%20farmers%20learning%20protein%20feed%20production%20from%20Black%20Soldier%20Fly%20larvae%2C%20demonstration%20of%20drying%20and%20packaging%20techniques%2C%20quality%20control%20training%20for%20insect-based%20products%2C%20hands-on%20practice%20with%20processing%20equipment%2C%20sustainable%20feed%20manufacturing%20education%2C%20professional%20agricultural%20training%20environment&width=600&height=400&seq=bsf-training-processing-003&orientation=landscape',
      topics: [
        'Larvae processing and drying methods',
        'Feed formulation and packaging',
        'Fertilizer production from frass',
        'Quality standards and certification',
        'Storage and distribution best practices'
      ],
      fullDescription: 'Master the art of processing BSF products with this specialized 2-day program. Learn professional techniques for processing larvae into high-quality protein meal and converting frass into premium organic fertilizer. This course covers everything from harvesting to packaging, ensuring you can produce market-ready products that meet international quality standards.',
      includes: [
        'Processing techniques manual',
        'Certificate of completion',
        'Quality control checklist',
        'Packaging design templates',
        'Market linkage support',
        '4 months technical support'
      ],
      schedule: 'Next session starts from January 2026. Contact us for detailed schedule and pricing.',
      showEnroll: false
    },
    {
      title: 'BSF Business Management',
      level: 'Professional',
      duration: '2 Days',
      price: 'On Request',
      image: 'https://readdy.ai/api/search-image?query=Agricultural%20business%20management%20training%20for%20BSF%20farming%20entrepreneurs%2C%20professional%20workshop%20on%20insect%20farming%20business%20planning%2C%20financial%20management%20and%20marketing%20strategies%20session%2C%20farmers%20learning%20about%20BSF%20product%20sales%20and%20distribution%2C%20business%20development%20training%20in%20modern%20conference%20room%2C%20sustainable%20agriculture%20entrepreneurship%20education&width=600&height=400&seq=bsf-training-business-004&orientation=landscape',
      topics: [
        'Financial planning and budgeting',
        'Marketing strategies for BSF products',
        'Customer relationship management',
        'Regulatory compliance and licensing',
        'Scaling your BSF business'
      ],
      fullDescription: 'Transform your BSF farming operation into a profitable business with our professional business management program. This 2-day intensive course covers financial planning, marketing strategies, regulatory compliance, and scaling techniques. Learn from successful BSF entrepreneurs and business consultants who will share proven strategies for building a sustainable and profitable BSF enterprise.',
      includes: [
        'Business management toolkit',
        'Professional certificate',
        'Financial planning templates',
        'Marketing strategy guide',
        'Legal compliance checklist',
        '3 months business mentorship'
      ],
      schedule: 'Next session starts from January 2026. Contact us for detailed schedule and pricing.',
      showEnroll: false
    }
  ];

  return (
    <section id="training-programs" className="py-20 bg-gradient-to-br from-green-50 to-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Training Programs
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive training programs designed to help you succeed in BSF farming and related businesses.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {programs.map((program, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 bg-gray-200 overflow-hidden">
                <img 
                  src={program.image} 
                  alt={program.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                    {program.level}
                  </span>
                  <span className="text-gray-600 text-sm flex items-center">
                    <i className="ri-time-line mr-1"></i>
                    {program.duration}
                  </span>
                </div>
                
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {program.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {program.description}
                </p>

                <div className="mb-4 pb-4 border-b border-gray-200">
                  <p className="text-2xl font-bold text-green-600">{program.price}</p>
                  <p className="text-sm text-gray-500 mt-1">{program.schedule}</p>
                </div>

                <div className={`flex gap-3 ${program.showEnroll ? '' : 'justify-center'}`}>
                  {program.showEnroll && (
                    <button 
                      onClick={handleEnrollNow}
                      className="flex-1 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Enroll Now
                    </button>
                  )}
                  <button 
                    onClick={() => handleLearnMore(program)}
                    className={`${program.showEnroll ? 'flex-1' : 'w-full'} border border-gray-300 hover:bg-gray-50 text-gray-700 py-2 px-4 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap`}
                  >
                    Learn More
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Product Detail Modal */}
      {selectedProgram && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setSelectedProgram(null)}>
          <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
              <h3 className="text-2xl font-bold text-gray-900">{selectedProgram.title}</h3>
              <button 
                onClick={() => setSelectedProgram(null)}
                className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="p-6">
              <div className="h-80 bg-gray-200 rounded-lg overflow-hidden mb-6">
                <img 
                  src={selectedProgram.image} 
                  alt={selectedProgram.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex items-center gap-4 mb-6">
                <span className="bg-green-100 text-green-800 px-4 py-2 rounded-lg font-medium">
                  {selectedProgram.level}
                </span>
                <span className="text-gray-600 flex items-center">
                  <i className="ri-time-line mr-2"></i>
                  {selectedProgram.duration}
                </span>
                <span className="text-2xl font-bold text-green-600 ml-auto">
                  {selectedProgram.price}
                </span>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Program Overview</h4>
                <p className="text-gray-600 leading-relaxed">{selectedProgram.fullDescription}</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-3">Topics Covered</h4>
                  <ul className="space-y-2">
                    {selectedProgram.topics.map((topic: string, index: number) => (
                      <li key={index} className="flex items-start text-gray-600">
                        <i className="ri-check-line text-green-600 mr-2 mt-1 flex-shrink-0"></i>
                        <span>{topic}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-3">What's Included</h4>
                  <ul className="space-y-2">
                    {selectedProgram.includes.map((item: string, index: number) => (
                      <li key={index} className="flex items-start text-gray-600">
                        <i className="ri-gift-line text-green-600 mr-2 mt-1 flex-shrink-0"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="bg-blue-50 rounded-lg p-4 mb-6">
                <h4 className="font-semibold text-gray-900 mb-2">Schedule</h4>
                <p className="text-gray-600">{selectedProgram.schedule}</p>
              </div>

              <div className="flex gap-4 pt-4 border-t border-gray-200">
                {selectedProgram.showEnroll ? (
                  <>
                    <button 
                      onClick={handleEnrollNow}
                      className="flex-1 bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Enroll in This Program
                    </button>
                    <button 
                      onClick={() => {
                        setSelectedProgram(null);
                        setTimeout(() => scrollToInquiryForm(), 100);
                      }}
                      className="flex-1 border-2 border-green-600 text-green-600 hover:bg-green-600 hover:text-white py-3 px-6 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Request More Information
                    </button>
                  </>
                ) : (
                  <button 
                    onClick={() => {
                      setSelectedProgram(null);
                      setTimeout(() => scrollToInquiryForm(), 100);
                    }}
                    className="w-full bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Request More Information
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}